import OvalSpinner from 'app/components/Common/Loaders/OvalSpinner';
import i18n from 'i18next';
import { NextPage } from 'next';
import { useCallback, useEffect, useState } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import MainLayout from '../../app/components/Layouts/MainLayout';
import ApiInterface from '../../app/modules/ApiInterface';

const ContactUs: NextPage = () => {
	const { t } = useTranslation();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const { executeRecaptcha } = useGoogleReCaptcha();

	// Create an event handler so you can call the verification on button click event or form submit
	const handleReCaptchaVerify = useCallback(async () => {
		if (!executeRecaptcha) {
			console.log('Execute recaptcha not yet available');
			return;
		}

		const token = await executeRecaptcha(process.env.NEXT_PUBLIC_RECAPTCHA_ACTION as string);

		setState({ ...state, captcha: token });
	}, [executeRecaptcha]);

	// You can use useEffect to trigger the verification as soon as the component being loaded
	useEffect(() => {
		handleReCaptchaVerify();
	}, [handleReCaptchaVerify]);

	const [state, setState] = useState({
		recaptchaSize: 'normal',
		name: '',
		email: '',
		subject: '',
		message: '',
		captcha: '',
		showSuccessMessage: false,
	});

	useEffect(() => {
		if (window.innerWidth < 575) {
			setState({ ...state, recaptchaSize: 'compact' });
		}
	}, []);

	const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setState((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};
	const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const { name, email, subject, message, captcha } = state;
		if (!name || !email || !message) {
			return;
		}
		const data = {
			name,
			email,
			subject,
			message,
			'g-recaptcha-response': captcha,
		};
		setIsSubmitting(true);

		ApiInterface.instance
			.contactUs('flights', JSON.stringify(data))
			.then(() => {
				showSuccessMessage();
				setState((prevState) => ({
					...prevState,
					name: '',
					email: '',
					subject: '',
					message: '',
					captcha: '',
				}));
				const messageElement = document.getElementById('message') as HTMLInputElement;
				if (messageElement) {
					messageElement.value = '';
				}
			})
			.catch((e: any) => {
				console.error(e);
			})
			.finally(() => {
				setIsSubmitting(false);
				setState((prevState) => ({
					...prevState,
					captcha: '',
				}));
			});
	};

	const showSuccessMessage = () => {
		setState({
			...state,
			showSuccessMessage: false,
		});
		setState({
			...state,
			showSuccessMessage: true,
		});
	};

	return (
		<MainLayout>
			<div className="container">
				<div className="row">
					<div className="col-12 mb-4" id="contact-us">
						<div className="title mt-4">{t('keywords.contactUs')}</div>
						{!state.showSuccessMessage && (
							<p
								dangerouslySetInnerHTML={{
									__html: i18n.t('contactUs.content'),
								}}
							/>
						)}
						<div className="row">
							<div className="col-12 col-md-10 col-lg-6 pt-4">
								{state.showSuccessMessage ? (
									<h4 className="alert alert-success">{t('contactUs.successMessage')}</h4>
								) : (
									<form onSubmit={onSubmitForm}>
										<div className="form-group mb-2">
											<label className="mb-1" htmlFor="">
												{t('keywords.name')}
											</label>
											<input
												onChange={onChange}
												value={state.name}
												name="name"
												required
												type="text"
												className="form-control"
												placeholder={t('keywords.name')}
											/>
										</div>

										<div className="form-group mb-2">
											<label className="mb-1" htmlFor="">
												{t('keywords.email')}
											</label>
											<input
												onChange={onChange}
												value={state.email}
												required
												type="email"
												name="email"
												className="form-control"
												placeholder={t('keywords.email')}
											/>
										</div>
										<div className="form-group mb-2">
											<label className="mb-1" htmlFor="">
												{t('keywords.subject')} ({t('keywords.optional')})
											</label>
											<input
												onChange={onChange}
												value={state.subject}
												name="subject"
												type="text"
												className="form-control"
												placeholder={`${t('keywords.subject')} (${t('keywords.optional')})`}
											/>
										</div>
										<div className="form-group ">
											<label className="mb-1" htmlFor="">
												{t('keywords.yourMessage')}
											</label>
											<textarea
												onChange={onChange}
												required
												name="message"
												id="message"
												cols={30}
												rows={4}
												className="form-control"
												placeholder={t('keywords.yourMessage')}
												value={state.message}
											/>
										</div>

										<div className="form-group mt-4 mb-4">
											<button className="btn btn-primary btn-blue" type="submit" disabled={isSubmitting}>
												{isSubmitting ? (
													<OvalSpinner
														height={30}
														width={30}
														color="#f2f2f2"
														wrapperStyle={{}}
														wrapperClass="d-flex justify-content-center"
														visible={true}
														ariaLabel="oval-loading"
														secondaryColor="#24234d"
														strokeWidth={6}
														strokeWidthSecondary={6}
													/>
												) : (
													<span>{t('keywords.send')}</span>
												)}
											</button>
										</div>
									</form>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</MainLayout>
	);
};

const ContactUsWIthRecaptcha = () => {
	return (
		<GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}>
			<ContactUs />
		</GoogleReCaptchaProvider>
	);
};

const mapStateToProps = (state: any) => ({
	lng: state.base.lng,
});
export default connect(mapStateToProps, {})(ContactUsWIthRecaptcha);
